"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.BigTitle = void 0;
var React = __importStar(require("react"));
var Utility_1 = require("../Utility");
var BigTitle = function (props) { return (React.createElement(Utility_1.ColorElement, __assign({ as: "h1" }, (0, Utility_1.handleUtility)(props, 't2-big-title')))); };
exports.BigTitle = BigTitle;
var H1 = function (props) { return React.createElement(Utility_1.ColorElement, __assign({ as: "h1" }, (0, Utility_1.handleUtility)(props, 't2-h1'))); };
exports.H1 = H1;
var H2 = function (props) { return React.createElement(Utility_1.ColorElement, __assign({ as: "h2" }, (0, Utility_1.handleUtility)(props, 't2-h2'))); };
exports.H2 = H2;
var H3 = function (props) { return React.createElement(Utility_1.ColorElement, __assign({ as: "h3" }, (0, Utility_1.handleUtility)(props, 't2-h3'))); };
exports.H3 = H3;
var H4 = function (props) { return React.createElement(Utility_1.ColorElement, __assign({ as: "h4" }, (0, Utility_1.handleUtility)(props, 't2-h4'))); };
exports.H4 = H4;
